export default function newsletter() {
//* --- Variabili e funzioni per controllare il form iscrizione Newsletter
    window.initialize_nlcb = function () {
        $('#nlform').submit(function (event) {
            var $form = $(this);

            // Se il captcha è già stato preso, procedi all'invio finale
            if ($form.attr('data-captcha-ready')) return true;

            // campi obbligatori e spunte privacy: validazione nativa del browser (attributo required)
            // --- VALIDAZIONE OK: AVVIA RECAPTCHA ---
            event.preventDefault();
            window.executeRecaptchaProcess($form[0], function(token) {
                $form.attr('data-captcha-ready', 'true');
                $form[0].submit(); // Invia bypassando jQuery
            });
        });
    }
}